import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { MessageType } from '@/models/message-type';
import { MessageToUser } from '@/models/message-to-user';

import { RootModule } from './root-module';
import { project } from './project-module';
import { startpage } from './startpage-module';

Vue.use(Vuex);

const store: StoreOptions<RootModule> = {
  state: {
    isLoading: false,
    message: {
      type: MessageType.NoMessage,
      message: '',
      errorCode: '',
    },
  },
  mutations: {
    setLoading(state, loading: boolean) {
      state.isLoading = loading;
    },
    setMessage(state, message: MessageToUser) {
      state.message = message;
    },
    dismissMessage(state) {
      state.message.type = MessageType.NoMessage;
    },
  },
  getters: {
    isLoading(state): boolean {
      return state.isLoading;
    },
    getMessage(state): MessageToUser {
      return state.message;
    },
  },
  modules: {
    project,
    startpage,
  },
};

export default new Vuex.Store<RootModule>(store);
